<header class="grid grid-cols-[64px_1fr] gap-3 items-center">
  <img
    [src]="signupUserService.user$.value?.avatar"
    onerror="this.src='/assets/images/signup/avatar.svg'"
    class="w-full h-auto" />

  <div>
    <h1 *ngIf="!signupUserService.user$.value?.first_name" class="text-2xl md:text-3xl">Hello there</h1>
    <h1 *ngIf="signupUserService.user$.value?.first_name" class="text-2xl md:text-3xl">
      Hey, {{ signupUserService.user$.value?.first_name }} 👋
    </h1>
    <span>Welcome {{ isReturning ? 'back to' : 'to' }} {{ 'CORE.PRODUCT_NAME' | transloco }}</span>
  </div>
</header>
